import React, { memo, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { BaseballTable } from "../tables/BaseballTable";
import { getTeamBattingColumns } from "../../config/teamBattingColumns";
import { getTeamPitchingColumns } from "../../config/teamPitchingColumns";
import { RosterCard } from "./RosterCard";
import { TeamGames } from "./TeamGames";
import { PitcherUtilization } from "./PitcherUtilization";
import { LineupUsage } from "./LineupUsage";
import { STAT_TYPES } from "./constants";

export const TeamContent = memo(({ activeTab, teamData, games, orgId, division, years }) => {
  const navigate = useNavigate();

  const battingColumns = useMemo(() => {
    const cols = getTeamBattingColumns();
    return cols.filter((c) => !["Team", "Conference", "Division"].includes(c.name));
  }, []);

  const pitchingColumns = useMemo(() => {
    const cols = getTeamPitchingColumns();
    return cols.filter((c) => !["Team", "Conference", "Division"].includes(c.name));
  }, []);

  if (activeTab === STAT_TYPES.ROSTER) {
    const roster = teamData?.roster || [];
    return (
      <div className="p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {roster.map((player) => (
            <RosterCard
              key={player.player_id}
              player={player}
              onClick={() => navigate(`/player/${player.player_id}`)}
            />
          ))}
        </div>
        {roster.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            No roster data available
          </div>
        )}
      </div>
    );
  }

  if (activeTab === STAT_TYPES.BATTING) {
    return (
      <div className="p-6">
        <BaseballTable
          title=""
          data={teamData?.batting_stats || []}
          columns={battingColumns}
          filename={`${teamData?.team_name}_batting.csv`}
          noDataComponent={
            <div className="text-center py-12 text-gray-500">
              No batting data available
            </div>
          }
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.PITCHING) {
    return (
      <div className="p-6">
        <BaseballTable
          title=""
          data={teamData?.pitching_stats || []}
          columns={pitchingColumns}
          filename={`${teamData?.team_name}_pitching.csv`}
          noDataComponent={
            <div className="text-center py-12 text-gray-500">
              No pitching data available
            </div>
          }
        />
      </div>
    );
  }

  if (activeTab === STAT_TYPES.GAMES) {
    return <TeamGames games={games} teamName={teamData?.team_name} />;
  }

  if (activeTab === STAT_TYPES.LINEUP) {
    return <LineupUsage orgId={orgId} division={division} years={years} />;
  }

  if (activeTab === STAT_TYPES.BULLPEN) {
    return <PitcherUtilization orgId={orgId} division={division} years={years} />;
  }

  return null;
});

TeamContent.displayName = "TeamContent";

